import SVG from 'react-inlinesvg';
import styles from './index.module.scss';

interface PromotionCarouselNextButtonProps {
  onClick: () => void;
}

export const PromotionCarouselNextButton = ({
  onClick,
}: PromotionCarouselNextButtonProps) => {
  return (
    <button
      className={`${styles['icon-container']} ${styles['next-icon-container']}`}
    >
      <SVG src="/assets/chevron-right-filled.svg" onClick={onClick} />
    </button>
  );
};
